import React from 'react'
import './tooltip.css'

interface TooltipProps {
  message: string
  children: React.ReactNode
}

const Tooltip: React.FC<TooltipProps> = ({ message, children }) => {
  return (
    <div className="tooltip-icon">
      {children}
      <p className="tooltip-icon__tooltip" style={{ whiteSpace: 'nowrap'}}>{message}</p>
    </div>
  )
}

export default Tooltip
